/**
 * GlobalTopBar — sticky header above the main content area.
 *
 * Renders two slots (left + right) supplied by the current page via
 * TopBarContext. Mounted inside AppLayout's <main>; the sidebar is
 * outside this component's DOM subtree, so the bar never overlays the
 * sidebar — it only pushes main content down by its own height.
 */

import type { ReactNode } from "react";
import { useTopBarSlots } from "./TopBarContext";
import GlobalTopBarActions from "./GlobalTopBarActions";
import styles from "../../styles/layout.module.css";

export default function GlobalTopBar(): ReactNode {
  const { left, right } = useTopBarSlots();

  return (
    <header className={styles.globalTopBar} data-testid="global-top-bar">
      <div className={styles.globalTopBarLeft} data-testid="global-top-bar-left">{left}</div>
      {/* Right region: page-injected extras (if any) sit to the left of the
          fixed global action cluster, keeping the global buttons in a
          consistent rightmost position across all top-bar pages. */}
      <div className={styles.globalTopBarRight} data-testid="global-top-bar-actions">
        {right}
        <GlobalTopBarActions />
      </div>
    </header>
  );
}
